export default __webpack_public_path__ + "static/media/1969.644ce168.png";